import {useQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import { authorizedGet, authorizedPost } from '../functions/AuthService';
import { getStatus, cleanBudget } from '../../containers/BudgetNormalizer';


export const useBudgets = () => {
    return useQuery({
        queryKey: ['budgets'],
        queryFn: async () => {
            const response = await authorizedGet("/budget/getAll");
            // console.log("Response: ", response.body.json());
            const resData =  await response.body.json();

            return resData.map(budget => ({
                ...budget, status: getStatus(budget)
            }));
        },
        staleTime: 1000 * 60 * 5, //5 minutes
        gcTime: 1000 * 60 * 15, //Keep it in memory for 15 minutes
        refetchOnWindowFocus: false //Prevent refresh if the tab is clicked
    })
};

export const useSaveBudget = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (data) => {
            const normalizedData = {...data, status: getStatus(data)}
            const cleanedData = cleanBudget(normalizedData);
            const response = await authorizedPost("/budget/senddatafiles", cleanedData)
            return await response.body.json();
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['budgets']});
        }
    })
}

export const useRequestApproval = () => {
    return useMutation({
        mutationFn: async (payload) => {
            const response = await authorizedPost("/budget/notify", {payload});
            return await response.body.json();
        }
    })
    }
